import { Component, OnInit } from '@angular/core';
import { IAgent, INewAgentStep } from '../../models/agents.models';
import { Router } from '@angular/router';
import { AppState } from 'src/app/core/app.state';
import { Store } from '@ngrx/store';
import { IPageCount } from 'src/app/shared/models/page.model';
import { DEFAULT_PAGE_SIZE } from 'src/app/config/global.config';
import { CommonService } from 'src/app/shared/common.service';
import {
  AddAgent,
  AddAgentSuccess,
} from '../../store/agents.actions';
import { TranslateService } from '@ngx-translate/core';
import { Actions, ofType } from '@ngrx/effects';
import { Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'app-new-agent',
  templateUrl: './new-agent.component.html',
  styleUrls: ['./new-agent.component.scss'],
})
export class NewAgentComponent implements OnInit {
  creationSteps: INewAgentStep[] = [
    { label: 'agent.agent_details', active: true, completed: false },
    { label: 'agent.agent_portfolio', active: false, completed: false },
    { label: 'agent.single_agent.tabs.catalogs', active: false, completed: false },
  ];

  activeStep!: INewAgentStep;
  currentStepIndex = 0;

  agentPayload!: IAgent;

  page: IPageCount = {
    size: DEFAULT_PAGE_SIZE,
    number: 1,
  };

  destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private store: Store<AppState>,
    private commonService: CommonService,
    private translateService: TranslateService,
    private actions: Actions
  ) {}

  ngOnInit(): void {
    this.activeStep = this.creationSteps[0];

    this.actions
      .pipe(
        ofType(AddAgentSuccess),
        tap(() => {
          this.router.navigate(['/agents']);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  get AgentDetailIsComplete() {
    return this.creationSteps[0].completed;
  }

  goToStep(index: number) {
    if (
      this.creationSteps[index].completed ||
      index !== this.currentStepIndex
    ) {
      this.creationSteps[this.currentStepIndex].active = false;
      this.currentStepIndex = index;
      this.creationSteps[this.currentStepIndex].active = true;
    }
  }

  previous(payload: any) {
    this.completeStep(payload);

    if (this.currentStepIndex - 1 >= 0) {
      this.currentStepIndex--;
      this.creationSteps[this.currentStepIndex].active = true;
      this.goToStep(this.currentStepIndex);
    }
  }

  next(payload: any) {
    this.completeStep(payload);

    if (this.currentStepIndex + 1 < this.creationSteps.length) {
      this.currentStepIndex++;
      this.creationSteps[this.currentStepIndex].active = true;
      this.goToStep(this.currentStepIndex);
    } else {
      if (!this.AgentDetailIsComplete) {
        this.commonService.showToast(
          this.translateService.instant('alerts.wizard.uncomplete_steps', { steps : '(' + this.translateService.instant('agent.agent_details') + ')'}),
          'WARNING',
          { duration: 3000 }
        );
        return;
      }

      this.store.dispatch(AddAgent({ agent: this.agentPayload }));
    }
  }

  completeStep(payload: any) {
    this.agentPayload = { ...this.agentPayload, ...payload };
    const activeStep = this.creationSteps[this.currentStepIndex];
    activeStep.completed = true;
    activeStep.active = false;
  }

  goBack() {
    this.router.navigate(['/agents']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
